import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { ImageAndTextBlockConfig } from '@front-platform/content-builder';
import { imageAndTextBlockResolveConfig } from '@front-platform/content-builder';
import { Component, OnInit, input } from '@angular/core';
import { IContentBuilderFieldImage } from '@core/models/content-builder-fields.model';
export interface ImageAndTextBlockRuntimeConfig {
  'anchor'?: string | undefined;
}

export type ImageAndTextBlockConfigInput = Partial<
  Omit<ImageAndTextBlockConfig, keyof ImageAndTextBlockRuntimeConfig> &
    ImageAndTextBlockRuntimeConfig
>;
export type ImageAndTextBlockResolvedConfig = Omit<
  ImageAndTextBlockConfig,
  keyof ImageAndTextBlockRuntimeConfig
> &
  Partial<ImageAndTextBlockRuntimeConfig>;
export interface ImageAndTextBlockContract extends ConfigComponentContract<
  ImageAndTextBlockConfigInput,
  ImageAndTextBlockResolvedConfig
> {}

@Component({
  selector: 'app-image-and-text-block',
  templateUrl: './image-and-text-block.component.html',
  standalone: false,
})
export class ImageAndTextBlockComponent implements OnInit, ImageAndTextBlockContract {
  readonly config = input<ImageAndTextBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    ImageAndTextBlockConfig,
    ImageAndTextBlockRuntimeConfig
  >(imageAndTextBlockResolveConfig, () => ({ config: this.config() }));
  IMAGE_POSITION_RIGHT = 'right';

  get fullWidth(): boolean {
    return this.resolvedConfig()['full_width'] as unknown as boolean;
  }
  get image(): IContentBuilderFieldImage | undefined {
    return this.resolvedConfig()['image'] as unknown as IContentBuilderFieldImage | undefined;
  }
  get content(): string | undefined {
    return this.resolvedConfig()['content'] as unknown as string | undefined;
  }
  get imagePosition(): string | undefined {
    return this.resolvedConfig()['image_position'] as unknown as string | undefined;
  }
  get imageVerticalPosition(): string {
    return this.resolvedConfig()['image_vertical_position'] as unknown as string;
  }
  get textVerticalPosition(): string {
    return this.resolvedConfig()['text_vertical_position'] as unknown as string;
  }
  get imageSize(): number {
    return this.resolvedConfig()['image_size'] as unknown as number;
  }
  get roundedImage(): boolean {
    return this.resolvedConfig()['rounded_image'] as unknown as boolean;
  }
  get anchor(): string | undefined {
    return this.resolvedConfig()['anchor'] as unknown as string | undefined;
  }
  imageWidthClass?: string;
  textWidthClass?: string;

  constructor() {}

  ngOnInit(): void {
    this.imageWidthClass = 'lg:w-' + this.imageSize + '/12';
    this.textWidthClass = 'lg:w-' + (12 - this.imageSize) + '/12';
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(ImageAndTextBlockComponent, { 'keyAliases': {} });
